<template>
  <div class="login-wrap" @touchmove.prevent>
    <div v-if="showPc" class="pc-wrap" :class="showPc ? '' : 'unshow'">
      <div class="logo">
        <img src="../assets/images/logo2.png" @click="goWeb" />
      </div>
      <div class="login-container">
        <div v-if="showLogin" class="login-info">
          <div v-if="inviteCode" class="login-info-invite">
            <img
              v-if="inviteInfos.inviterAvatar"
              :src="inviteInfos.inviterAvatar"
            />
            <use-svg v-else icon="headAvatar"></use-svg>
            <div class="login-info-invite-user">
              <span>{{ inviteInfos.inviterName }}</span>
              <span>邀请你加入</span>
            </div>
            <p class="login-info-invite-team">
              <span>{{ inviteInfos.teamName }}</span
              >团队
            </p>
          </div>
          <!--      登录-->
          <div
            v-if="loginTab === '1'"
            class="login-box"
            :class="inviteCode ? 'is-invite' : ''"
          >
            <div class="login-tab">
              <div
                class="msg"
                :class="activeTab === '1' ? 'active' : ''"
                @click="handleTabChange('1')"
              >
                短信登录
              </div>
              <div class="line"></div>
              <div
                class="pwd"
                :class="activeTab === '2' ? 'active' : ''"
                @click="handleTabChange('2')"
              >
                密码登录
              </div>
            </div>
            <template v-if="activeTab === '1'">
              <a-form-model
                :model="msgLoginForm"
                ref="msgLoginForm"
                :rules="msgLoginRules"
              >
                <a-form-model-item prop="phone">
                  <a-input
                    v-model="msgLoginForm.phone"
                    :maxLength="11"
                    placeholder="请输入手机号"
                    allowClear
                  ></a-input>
                </a-form-model-item>
                <a-form-model-item prop="code">
                  <a-input
                    v-model="msgLoginForm.code"
                    @pressEnter="handleLogin"
                    :maxLength="8"
                    placeholder="请输入验证码"
                  ></a-input>
                  <div class="verify-code">
                    <div
                      class="get-code"
                      v-if="verifyStatus == 1"
                      @click="sendCode"
                    >
                      获取验证码
                    </div>
                    <div v-else-if="verifyStatus == 2" class="down-time">
                      {{ loginTimeCount }} 秒后重发
                    </div>
                    <div class="get-code" v-else @click="sendCode">
                      重新发送
                    </div>
                  </div>
                </a-form-model-item>
              </a-form-model>
              <a-button
                class="login-btn"
                :loading="msgLoginLoading"
                @click="handleLogin"
                >登录</a-button
              >
              <a-checkbox v-model="msgLoginForm.checkProtocol">
                我已阅读并同意<span
                  class="protocol"
                  @click.stop="handelAgreement(1)"
                  >《用户协议》</span
                >
                和<span class="protocol" @click.stop="handelAgreement(2)"
                  >《隐私协议》</span
                >
              </a-checkbox>
            </template>
            <template v-else>
              <a-form-model
                :model="pwdLoginForm"
                ref="pwdLoginForm"
                :rules="pwdLoginRules"
              >
                <a-form-model-item prop="phone">
                  <a-input
                    @blur="inputFocusOut"
                    @focus="inputFocus(1)"
                    v-model="pwdLoginForm.phone"
                    :maxLength="11"
                    placeholder="请输入手机号"
                    allowClear
                  ></a-input>
                </a-form-model-item>
                <a-form-model-item prop="pwd">
                  <a-input-password
                    @blur="inputFocusOut"
                    @focus="inputFocus(2)"
                    @pressEnter="handleLogin"
                    v-model="pwdLoginForm.pwd"
                    :maxLength="16"
                    placeholder="请输入密码"
                    allowClear
                  ></a-input-password>
                </a-form-model-item>
                <div
                  class="appid-list"
                  :class="focusType == 1 ? 'account' : 'pwd'"
                  v-show="
                    userAgent == 'UnrealBoxClient' &&
                    showAppidModal &&
                    accountList.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in accountList"
                    :key="index"
                    @click="handleSelectAppid(item)"
                    class="item"
                  >
                    <p class="item-account">{{ item.account }}</p>
                    <p class="password">{{ convertToStars(item.password) }}</p>
                  </div>
                </div>
                <div
                  class="forget-pwd"
                  :class="userAgent == 'UnrealBoxClient' ? 'client' : ''"
                >
                  <a-checkbox
                    v-if="userAgent == 'UnrealBoxClient'"
                    v-model="isRemberPassword"
                    class="checkbox-password"
                    >记住密码</a-checkbox
                  >
                  <div
                    v-if="activeTab === '2'"
                    class="forget-btn"
                    @click="handleForgetPwd"
                  >
                    忘记密码
                  </div>
                </div>
              </a-form-model>
              <a-button
                class="login-btn"
                :loading="pwdLoginLoading"
                @click="handleLogin"
                >登录</a-button
              >
              <a-checkbox v-model="pwdLoginForm.checkProtocol">
                我已阅读并同意<span
                  class="protocol"
                  @click.stop="handelAgreement(1)"
                  >《用户协议》</span
                >
                和<span class="protocol" @click.stop="handelAgreement(2)"
                  >《隐私协议》</span
                >
              </a-checkbox>
            </template>
          </div>

          <!--      找回密码-->
          <div v-else class="pwd-box">
            <div class="title">找回密码</div>
            <a-form-model
              :model="findPwdForm"
              ref="findPwdForm"
              :rules="findPwdRules"
            >
              <a-form-model-item prop="phone">
                <a-input
                  v-model="findPwdForm.phone"
                  :maxLength="11"
                  placeholder="请输入手机号"
                  allowClear
                ></a-input>
              </a-form-model-item>
              <a-form-model-item prop="code">
                <a-input
                  v-model="findPwdForm.code"
                  :maxLength="11"
                  placeholder="请输入验证码"
                ></a-input>
                <div class="verify-code">
                  <div
                    class="get-code"
                    v-if="verifyPwdStatus == 1"
                    @click="sendPwdCode"
                  >
                    获取验证码
                  </div>
                  <div v-else-if="verifyPwdStatus == 2" class="down-time">
                    {{ pwdTimeCount }} 秒后重发
                  </div>
                  <div class="get-code" v-else @click="sendPwdCode">
                    重新发送
                  </div>
                </div>
              </a-form-model-item>
              <a-form-model-item prop="pwd">
                <a-input-password
                  v-model="findPwdForm.pwd"
                  :maxLength="16"
                  placeholder="请输入新密码（8-16位数字或字母）"
                  allowClear
                ></a-input-password>
              </a-form-model-item>
              <a-form-model-item prop="pwdConfirm">
                <a-input-password
                  v-model="findPwdForm.pwdConfirm"
                  :maxLength="16"
                  placeholder="请再次输入密码"
                  allowClear
                ></a-input-password>
              </a-form-model-item>
            </a-form-model>
            <a-button
              class="login-btn"
              :loading="findPwdLoading"
              @click="handleSaveAndLogin"
              >保存并登录</a-button
            >
            <a-checkbox v-model="findPwdForm.checkProtocol"
              >我已阅读并同意<span
                class="protocol"
                @click.stop="handelAgreement(1)"
                >《用户协议》</span
              >和<span class="protocol" @click.stop="handelAgreement(2)"
                >《隐私协议》</span
              ></a-checkbox
            >
            <div class="remember-pwd">
              想起密码？<span @click="handleLoginTab">立即登录</span>
            </div>
          </div>
        </div>

        <!--      第一次登录选择团队-->
        <div v-else class="login-select">
          <p class="login-select-title">选择团队</p>
          <div class="team-box">
            <div
              v-for="(item, index) in teamList"
              :key="index"
              :value="item.id"
              :class="currentTeam == item.id ? 'active' : ''"
              @click="handleSelectTeam(item.id)"
            >
              <span class="name">{{ item.name }}</span>
              <span v-if="currentTeam == item.id" class="icon">
                <a-icon type="check" />
              </span>
            </div>
          </div>
          <a-button
            class="btn-light-sm login-select-btn"
            :disabled="inDisabled"
            @click="goHome"
            >进入团队</a-button
          >
        </div>
      </div>
      <div class="bottom-title" @click="goto">
        备案号：<span>浙ICP备2022032273号-1</span>
      </div>
    </div>
    <div v-else class="phone-wrap" :class="showPc ? 'unshow' : ''">
      <div class="logo">
        <img src="../assets/images/logo2.png" />
      </div>
      <div class="login-container">
        <h2>欢迎来到虚幻盒子</h2>
        <a-input
          v-model="phoneMobile"
          :maxLength="11"
          placeholder="请输入手机号"
          allowClear
        ></a-input>
        <a-button
          class="login-btn"
          :disabled="getCodeDisabled"
          :loading="phoneLoginLoading"
          @click="handleGetPhoneCode"
          >获取验证码</a-button
        >
        <a-checkbox v-model="phoneCheckProtocol"
          >我已阅读并同意<span class="protocol" @click.stop="handelAgreement(1)"
            >《用户协议》</span
          >和<span class="protocol" @click.stop="handelAgreement(2)"
            >《隐私政策》</span
          ></a-checkbox
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getInviteInfo, getTeamList, switchTeam } from '@/api/personal/team';
import {
  changePwd,
  findCodePwdSms,
  findPwdSms,
  getSecurityInfo,
  getSecurityKey,
  loginSms,
  msgLogin,
} from '@/api/personal/login';
import JSEncrypt from 'jsencrypt';
import { handleRobOrder } from '@/api/personal/task';
import { getCookie, setCookie } from '@/utils/util';
export default {
  data() {
    return {
      showPc: true,
      showLogin: true,
      inviteCode: '',
      from: '',
      urlType: '',
      webRobId: null,
      inviteInfos: {},
      loginTab: '1',
      activeTab: '1',
      token: '',
      msgLoginForm: {
        phone: '',
        code: '',
        checkProtocol: true,
      },
      msgLoginRules: {
        phone: [
          { required: true, trigger: 'blur', validator: this.phoneCheck },
        ],
        code: [{ required: true, trigger: 'blur', message: '请输入验证码' }],
      },
      msgLoginLoading: false,
      pwdLoginForm: {
        phone: '',
        pwd: '',
        checkProtocol: true,
      },
      pwdLoginRules: {
        phone: [
          { required: true, trigger: 'blur', validator: this.phoneCheck },
        ],
        pwd: [{ required: true, trigger: 'blur', message: '请输入密码' }],
      },
      pwdLoginLoading: false,
      loginTimeCount: 60,
      verifyStatus: 1,
      loginTimer: null,
      findPwdForm: {
        phone: '',
        code: '',
        pwd: '',
        pwdConfirm: '',
        checkProtocol: true,
      },
      findPwdRules: {
        phone: [
          { required: true, trigger: 'blur', validator: this.phoneCheck },
        ],
        code: [{ required: true, trigger: 'blur', message: '请输入验证码' }],
        pwd: [
          { required: true, trigger: 'blur', validator: this.passwordCheck },
        ],
        pwdConfirm: [
          { required: true, trigger: 'blur', validator: this.confirmCheck },
        ],
      },
      verifyPwdStatus: 1,
      pwdTimeCount: 60,
      pwdTimer: null,
      findPwdLoading: false,
      currentTeam: undefined,
      teamList: [],
      inDisabled: true,
      userAgent: navigator.userAgent.split('|')[1],
      shareId: '',
      showAppidModal: false,
      accountList: [],
      focusType: 1,
      isRemberPassword: true,
      phoneMobile: '',
      phoneCheckProtocol: true,
      phoneLoginLoading: false,
      // getCodeDisabled:true,
      isEncryption: false
    };
  },
  computed: {
    getCodeDisabled() {
      // 根据手机号长度判断按钮是否可用
      return this.phoneMobile.length !== 11;
    },
  },
  beforeRouteLeave(to, from, next) {
    to.query.shareCode = this.webRobId;
    next();
  },
  beforeDestroy() {
    clearInterval(this.loginTimer);
    clearInterval(this.pwdTimer);
  },
  mounted() {
    if (this.userAgent == 'UnrealBoxClient') {
      this.activeTab = '2';
    }
    console.log(window.innerWidth, '宽度11');
    if (window.innerWidth > 750) {
      this.showPc = true;
    } else {
      this.showPc = false;
    }
    window.addEventListener('resize', this.resizeFn);
    sessionStorage.removeItem('token');
    this.inviteCode = this.$route.query.inviteCode;
    this.shareId = this.$route.query.shareId;
    this.from = this.$route.query?.from;
    this.urlType = this.$route.query?.type;
    this.webRobId = this.$route.query?.id;
    if(this.$route.query?.isEncryption == 'true'){
      sessionStorage.setItem('isEncryption', 'true');
      this.isEncryption = true;
    }else{
      this.isEncryption = sessionStorage.getItem('isEncryption') == 'true' ? true : false;
    }
    if (this.inviteCode) {
      this.getInviteInfo();
    }
    if (this.userAgent == 'UnrealBoxClient') {
      this.getLoginList();
    }
    this.$store.commit('new_websocket', false);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeFn);
  },
  methods: {
    resizeFn() {
      if (window.innerWidth > 750) {
        this.showPc = true;
      } else {
        this.showPc = false;
      }
    },
    goWeb() {
      if (window.location.host.indexOf(':7072') > 0) {
        window.open(`https://ubtest.ver.cn:7072`);
      } else if (
        window.location.host.indexOf('test') > -1 ||
        window.location.host.indexOf('192') > -1
      ) {
        window.open(`http://127.0.0.1:60010`);
      } else {
        window.open(`https://www.unrealbox.com`);
      }
    },
    inputFocus(type) {
      setTimeout(() => {
        this.focusType = type;
        this.showAppidModal = true;
      }, 300);
    },
    inputFocusOut() {
      setTimeout(() => {
        this.showAppidModal = false;
      }, 200);
    },
    getLoginList() {
      window.ipc.invoke('app.getUserInfo', {}).then(res => {
        if (res) {
          console.log(res, '登录密码们');
          let arr = res || [];
          arr.map(i => {
            let obj = {
              account: i.account,
              password: i.password,
              remember: i.remember,
            };
            if (i.remember) {
              this.accountList.push(obj);
            }
          });
          if (this.accountList.length > 0) {
            this.isRemberPassword = this.accountList[0].remember;
            this.handleSelectAppid(this.accountList[0]);
          }
        }
      });
    },
    handleSelectAppid(item) {
      this.showAppidModal = false;
      this.pwdLoginForm.phone = item.account;
      this.pwdLoginForm.pwd = item.password;
    },
    convertToStars(str) {
      // 使用split方法将字符串分割成字符数组
      // 然后使用map方法将每个字符映射为星号
      // 最后使用join方法将数组合并成一个新的字符串
      return (
        str
          ?.split('')
          .map(char => '*')
          .join('') || ''
      );
    },
    handleTabChange(val) {
      if (val == '1') {
        this.$refs.pwdLoginForm.clearValidate();
      } else {
        this.$refs.msgLoginForm.clearValidate();
      }
      this.msgLoginLoading = false;
      this.pwdLoginLoading = false;
      this.activeTab = val;
    },
    // 发送验证码
    sendCode() {
      let validFlag = true;
      this.$refs.msgLoginForm.validateField('phone', valid => {
        if (valid) {
          validFlag = false;
          return false;
        }
      });
      if (!validFlag) {
        return false;
      }
      // 验证码登录
      let params = {
        mobile: this.msgLoginForm.phone,
      };
      loginSms(params).then(({ code, data }) => {
        if (code == 200) {
          this.verifyStatus = 2;
          this.loginTimer = setInterval(() => {
            this.loginTimeCount--;
            if (this.loginTimeCount == 0) {
              this.loginTimeCount = 60;
              this.verifyStatus = 3;
              clearInterval(this.loginTimer);
            }
          }, 1000);
        }
      });
    },
    phoneCheck: function (rule, value, callbackFn) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!value && value !== 0) {
        return callbackFn('手机号不能为空！');
      }
      if (!reg.test(value)) {
        return callbackFn('手机号格式错误！');
      }
      return callbackFn();
    },
    passwordCheck: function (rule, value, callbackPa) {
      // const reg = /^[0-9a-zA-Z]{8,16}$/
      // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
      const reg = /^(?![0-9]+$)[0-9A-Za-z]{8,16}$/;
      if (!value && value !== 0) {
        return callbackPa('密码不能为空！');
      }
      if (!reg.test(value)) {
        return callbackPa('密码必须是8-16位英文字母、数字组合（不能是纯数字）');
      }
      return callbackPa();
    },
    confirmCheck: function (rule, value, callbackCo) {
      let password = this.findPwdForm.pwd;
      if (!value && value !== 0) {
        return callbackCo('密码不能为空！');
      }
      if (value != password) {
        return callbackCo('两次密码输入不一致！');
      }
      return callbackCo();
    },
    // 登录 注册即登录
    handleLogin() {
      if (this.activeTab === '1') {
        // 验证码登录
        this.$refs.msgLoginForm.validate(valid => {
          if (valid) {
            if (!this.msgLoginForm.checkProtocol) {
              this.$message.warning('请勾选同意用户协议和隐私协议');
            } else {
              this.msgLoginLoading = true;
              let encryptData = {
                mobile: this.msgLoginForm.phone,
                code: this.msgLoginForm.code,
              };
              msgLogin(encryptData)
                .then(({ code, data }) => {
                  if (code == 200) {
                    let base = '';
                    if (
                      window.location.host.indexOf(':7072') > 0 ||
                      window.location.host.indexOf('test') > -1 ||
                      window.location.host.indexOf('192') > -1
                    ) {
                      //本地开发环境
                      base = 'https://ubtask.ver.cn:7072/api/task';
                      // base = "http://192.168.10.182:7072/api/task";
                    } else {
                      //线上正式环境
                      base = 'https://api.unrealbox.com/api/task';
                    }
                    let userInfo = {
                      mobile: encryptData.mobile,
                      userId: data.userId,
                      token: data.token,
                      baseurl: base,
                    };
                    this.token = data.token;
                    sessionStorage.setItem(
                      'userInfo',
                      JSON.stringify(userInfo)
                    );
                    sessionStorage.setItem('token', data.token);
                    sessionStorage.setItem('userId', data.userId);
                    this.pwdLoginLoading = false;
                    this.findPwdLoading = false;
                    if (this.userAgent == 'UnrealBoxClient') {
                      if(this.isEncryption){
                        let clientParams = {
                          token: data.token,
                        };
                        console.log(clientParams, this.isEncryption, '是否加密客户端-验证码')
                        window.ipc
                            .invoke('app.unrealboxLogin', clientParams)
                            .then(res => {
                              this.msgLoginLoading = false;
                              this.handlePush(data);
                            })
                            .catch(err => {
                              console.log(err,'错误信息')
                              this.msgLoginLoading = false;
                              this.$message.warning('应用程序登录失败');
                            });
                      }else{
                        console.log('非加密客户端-验证码')
                        this.msgLoginLoading = false;
                        this.handlePush(data);
                      }
                    } else {
                      this.msgLoginLoading = false;
                      this.handlePush(data);
                    }
                  } else {
                    this.msgLoginLoading = false;
                  }
                })
                .catch(() => {
                  this.msgLoginLoading = false;
                });
            }
          }
        });
      } else {
        // 密码登录
        this.$refs.pwdLoginForm.validate(valid => {
          if (valid) {
            if (!this.pwdLoginForm.checkProtocol) {
              this.$message.warning('请勾选同意用户协议和隐私协议');
            } else {
              this.pwdLoginLoading = true;
              let encryptData = {
                mobile: this.pwdLoginForm.phone,
                password: this.pwdLoginForm.pwd,
              };
              this.handleAfterLogin(encryptData);
            }
          }
        });
      }
    },
    handelAgreement(type) {
      if (type == 1) {
        window.open('/agreement/UsersAgreement.html');
      } else {
        window.open('/agreement/PrivacyAgreement.html');
      }
    },
    // 忘记密码
    handleForgetPwd() {
      this.$refs.pwdLoginForm.clearValidate();
      clearInterval(this.loginTimer);
      this.loginTab = '2';
      this.verifyStatus = 1;
      this.loginTimeCount = 60;
      this.findPwdLoading = false;
    },
    sendPwdCode() {
      let validFlag = true;
      this.$refs.findPwdForm.validateField('phone', valid => {
        if (valid) {
          validFlag = false;
          return false;
        }
      });
      if (!validFlag) {
        return false;
      }
      // 验证码登录
      let params = {
        mobile: this.findPwdForm.phone,
      };
      findPwdSms(params).then(({ code, data }) => {
        if (code == 200) {
          this.verifyPwdStatus = 2;
          this.pwdTimer = setInterval(() => {
            this.pwdTimeCount--;
            if (this.pwdTimeCount == 0) {
              this.pwdTimeCount = 60;
              this.verifyPwdStatus = 3;
              clearInterval(this.pwdTimer);
            }
          }, 1000);
        }
      });
    },
    // 保存并登录
    handleSaveAndLogin() {
      this.$refs.findPwdForm.validate(valid => {
        if (valid) {
          if (!this.findPwdForm.checkProtocol) {
            this.$message.warning('请勾选同意用户协议和隐私协议');
          } else {
            this.findPwdLoading = true;
            let params = {
              mobile: this.findPwdForm.phone,
              password: this.findPwdForm.pwd,
              code: this.findPwdForm.code,
              confirm: this.findPwdForm.pwdConfirm,
            };
            //用户修改密码
            changePwd(params)
              .then(({ code, data }) => {
                if (code == 200) {
                  this.$message.success('修改成功!');
                  let encryptData = {
                    mobile: this.findPwdForm.phone,
                    password: this.findPwdForm.pwd,
                  };
                  this.handleAfterLogin(encryptData);
                } else {
                  this.findPwdLoading = false;
                }
              })
              .catch(() => {
                this.findPwdLoading = false;
              });
          }
        }
      });
    },
    handleLoginTab() {
      this.$refs.findPwdForm.clearValidate();
      clearInterval(this.pwdTimer);
      this.loginTab = '1';
      this.verifyPwdStatus = 1;
      this.pwdTimeCount = 60;
      this.msgLoginLoading = false;
      this.pwdLoginLoading = false;
    },
    handleAfterLogin(encryptData) {
      getSecurityKey()
        .then(({ code, data }) => {
          if (code == 200) {
            let publicKey = data.securityKey;

            //使用公钥进行加密
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(publicKey);
            let encrypted = encrypt.encrypt(JSON.stringify(encryptData));

            let params = {
              uuid: data.uuid,
              ciphertext: encrypted,
            };

            getSecurityInfo(params)
              .then(({ code, data, message }) => {
                if (code == 200) {
                  let base = '';
                  if (
                    window.location.host.indexOf(':7072') > 0 ||
                    window.location.host.indexOf('test') > -1 ||
                    window.location.host.indexOf('192') > -1
                  ) {
                    //本地开发环境
                    base = 'https://ubtask.ver.cn:7072/api/task';
                    // base = "http://192.168.10.182:7072/api/task";
                  } else {
                    //线上正式环境
                    base = 'https://api.unrealbox.com/api/task';
                  }

                  let userInfo = {
                    mobile: encryptData.mobile,
                    password: encryptData.password,
                    userId: data.userId,
                    token: data.token,
                    baseurl: base,
                  };
                  this.token = data.token;
                  sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
                  sessionStorage.setItem('token', data.token);
                  sessionStorage.setItem('userId', data.userId);
                  if (this.userAgent == 'UnrealBoxClient') {
                    let clientParams = {
                      account: this.pwdLoginForm.phone,
                      password: this.pwdLoginForm.pwd,
                      remember: this.isRemberPassword,
                    };
                    if(this.isEncryption){
                      clientParams.token = data.token
                    }
                    console.log(clientParams, this.isEncryption, '是否加密客户端-密码')
                    window.ipc
                      .invoke('app.unrealboxLogin', clientParams)
                      .then(res => {
                        this.pwdLoginLoading = false;
                        this.findPwdLoading = false;
                        this.handlePush(data);
                      })
                      .catch(err => {
                        console.log(err,'错误信息')
                        this.pwdLoginLoading = false;
                        this.findPwdLoading = false;
                        this.$message.warning('应用程序登录失败');
                      });
                  } else {
                    this.pwdLoginLoading = false;
                    this.findPwdLoading = false;
                    this.handlePush(data);
                  }
                } else {
                  this.$message.error(message);
                  this.pwdLoginLoading = false;
                  this.findPwdLoading = false;
                }
              })
              .catch(() => {
                this.pwdLoginLoading = false;
                this.findPwdLoading = false;
              });
          } else {
            this.pwdLoginLoading = false;
            this.findPwdLoading = false;
          }
        })
        .catch(() => {
          this.pwdLoginLoading = false;
          this.findPwdLoading = false;
        });
    },
    // 处理登录成功的跳转（localStorage时效性影响）
    handlePush(val) {
      setCookie(val.token);
      if (this.inviteCode) {
        setTimeout(() => {
          this.$router.push({
            path: '/invite/apply',
            query: { inviteCode: this.inviteCode },
          });
        }, 0);
      } else {
        // this.getUserAuthList(val);
        // 只有一个团队时直接进入
        // 设置过默认团队就进入默认团队
        // 第一次登录选择团队，下次登录默认上一次的团队
        if (val.needChooseTeam) {
          // 需要选择团队
          this.getTeamList();
        } else {
          this.currentTeam = val.teamId;
          this.handleAfterSelectTeam();
        }
      }
      // if(this.from == 'web'){
      //   // 从官网点击登录过来 回到官网
      //   if (window.location.host.indexOf(":7072") > 0){
      //     window.location.href = `https://ubtest.ver.cn:7072`;
      //   }else if(window.location.host.indexOf("test") > -1 || window.location.host.indexOf("192") > -1){
      //     window.location.href = `http://127.0.0.1:60010?tk=${val.token}`;
      //   }else{
      //     window.location.href = `https://www.unrealbox.com`;
      //   }
      // }else if(this.from == 'webTask'){
      //   if(this.urlType == 'login'){
      //     // 从网站任务详情 登录 过来 回去
      //     this.$router.go(-1)
      //   }else{
      //     // 从网站任务详情 抢单 过来 抢单后回去
      //     handleRobOrder({id: this.webRobId}).then(({code,data}) => {
      //       if (code == 200) {
      //         if (data) {
      //           this.$message.success('抢单成功');
      //           // 去任务管理
      //           this.$router.push({path: '/task/list'});
      //         }
      //       }else{
      //         // 抢单失败 回到官网
      //         this.$router.go(-1);
      //       }
      //     })
      //   }
      // }else{
      //   let pushTimer = setInterval(() => {
      //     if (sessionStorage.getItem('token')) {
      //       clearInterval(pushTimer);
      //       pushTimer = null;
      //       if(this.inviteCode){
      //         setTimeout(()=>{
      //           this.$router.push({path: '/invite/apply', query: {inviteCode: this.inviteCode}});
      //         },0)
      //       }else{
      //         this.getUserAuthList(val);
      //       }
      //     }
      //   }, 100)
      // }
    },
    // getUserAuthList(loginData){
    //   setTimeout(()=>{
    //     // 只有一个团队时直接进入
    //     // 设置过默认团队就进入默认团队
    //     // 第一次登录选择团队，下次登录默认上一次的团队
    //     if(loginData.needChooseTeam){
    //       // 需要选择团队
    //       this.getTeamList();
    //     }else{
    //       this.handleAfterSelectTeam();
    //       // sessionStorage.setItem('currentTeamId', loginData.teamId);
    //       // if(this.shareId){
    //       //   this.$router.push({ path: '/task/rob' });
    //       // }else{this.$router.push({path: '/personal'});
    //       // }
    //     }
    //   },0)
    // },
    // 获取团队列表
    getTeamList() {
      getTeamList().then(({ code, data }) => {
        if (code == 200) {
          this.showLogin = false;
          this.teamList = data || [];
        }
      });
    },
    getInviteInfo() {
      getInviteInfo(this.inviteCode).then(({ code, data }) => {
        if (code == 200) {
          this.inviteInfos = { ...data };
          if (data?.isExpires) {
            this.$router.push({ path: '/invite/invalid' });
          } else {
            this.$router.push({
              path: '/invite/apply',
              query: { inviteCode: this.inviteCode },
            });
          }
        }
      });
    },
    handleSelectTeam(val) {
      this.currentTeam = val;
      if (this.currentTeam) {
        this.inDisabled = false;
      }
    },
    goHome() {
      if (!this.currentTeam) {
        this.$message.error('请选择要进入的团队');
      } else {
        switchTeam({ id: this.currentTeam }).then(({ code }) => {
          if (code == 200) {
            this.handleAfterSelectTeam();
            // sessionStorage.setItem('currentTeamId', this.currentTeam);
            // if(this.shareId){
            //   this.$router.push({ path: '/task/rob' });
            // }else {
            //   this.$router.push({path: '/personal'});
            // }
          }
        });
      }
    },
    // 选择团队后判断跳转页面
    handleAfterSelectTeam() {
      if (this.from == 'web') {
        if (this.urlType == 'appoint') {
          //   从官网立即约稿进来 进入需求页
          this.$router.push('/demand/list');
        } else {
          // 从官网点击登录过来 回到官网
          this.$router.go(-1);
        }
        // if (window.location.host.indexOf(':7072') > 0) {
        //   window.location.href = `https://ubtest.ver.cn:7072`;
        // } else if (
        //   window.location.host.indexOf('test') > -1 ||
        //   window.location.host.indexOf('192') > -1
        // ) {
        //   window.location.href = `http://127.0.0.1:60010?tk=${this.token}`;
        // } else {
        //   window.location.href = `https://www.unrealbox.com`;
        // }
      } else if (this.from == 'webTask') {
        if (this.urlType == 'login') {
          // 从网站任务详情 登录 过来 回去
          this.$router.go(-1);
        } else {
          // 从网站任务详情 抢单 过来 抢单后回去
          handleRobOrder({ id: this.webRobId }).then(({ code, data }) => {
            if (code == 200) {
              if (data) {
                this.$message.success('抢单成功');
                // 去任务管理
                this.$router.push({ path: '/task/list' });
              }
            } else {
              // 抢单失败 回到官网
              this.$router.go(-1);
            }
          });
        }
      } else {
        sessionStorage.setItem('currentTeamId', this.currentTeam);
        if (this.shareId) {
          this.$router.push({ path: '/task/rob' });
        } else {
          this.$router.push({ path: '/personal' });
        }
      }
    },
    goto() {
      window.open('https://beian.miit.gov.cn');
    },
    // 手机端
    handleGetPhoneCode() {
      if (!this.phoneCheckProtocol) {
        // 如果未勾选协议，弹出提示框
        this.$confirm({
          icon: 'none',
          // content: '请先阅读并同意《用户服务协议》和《隐私政策》',
          content: () => (
            <div>
              已阅读并同意
              <span class="protocol-link">《用户协议》</span> 和
              <span class="protocol-link">《隐私政策》</span>
            </div>
          ),
          okText: '同意并登录',
          cancelText: '不同意',
          class: 'check-light-confirm',
          onOk: () => {
            this.phoneCheckProtocol = true;
            this.getPhoneCode();
            console.log('用户确认了提示');
          },
          onCancel: () => {
            console.log('用户取消了提示');
          },
        });
        return;
      }

      // 如果已勾选协议，则执行获取验证码逻辑
      this.getPhoneCode();
    },
    // 获取验证码
    getPhoneCode() {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.phoneMobile && this.phoneMobile !== 0) {
        this.$message.warning('请输入手机号');
        return;
      }
      if (!reg.test(this.phoneMobile)) {
        this.$message.warning('手机号格式错误');
        return;
      }
      if (!this.phoneCheckProtocol) {
        this.$message.warning('请勾选同意用户协议和隐私协议');
        return;
      }
      // this.$router.push({path: '/phoneCodeLogin',query: {phone: this.phoneMobile}});
      this.phoneLoginLoading = true;
      let params = {
        mobile: this.phoneMobile,
      };
      findCodePwdSms(params)
        .then(({ code, data }) => {
          if (code == 200) {
            this.phoneLoginLoading = false;
            // 跳转到输入验证码页面
            this.verifyPwdStatus = 2;
            this.pwdTimer = setInterval(() => {
              this.pwdTimeCount--;
              if (this.pwdTimeCount == 0) {
                this.pwdTimeCount = 60;
                this.verifyPwdStatus = 3;
                clearInterval(this.pwdTimer);
              }
            }, 1000);
            this.$router.push({
              path: '/phoneCodeLogin',
              query: { phone: this.phoneMobile, from: this.from },
            });
          } else {
            this.phoneLoginLoading = false;
          }
        })
        .catch(() => {
          this.phoneLoginLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/common/styles/base/_mixin-font.scss';
.login-wrap {
  position: relative;
  height: 100%;
  overflow: hidden;
  .pc-wrap {
    height: 100%;
    background-image: url('../assets/images/login_bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    &.unshow {
      display: none;
    }
    .logo {
      position: absolute;
      top: 35px;
      left: calc((100% - 1200px) / 2);
      width: 124px;
      height: 29px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .login-container {
      width: 520px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: var(--font-color-white-one);
      box-shadow: 0 4px 6px 0 #0000001a;
      border-radius: 32px;

      .login-info {
        &-invite {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 210px;
          background-image: url('../assets/images/invite_bg.png');
          border-radius: 32px 32px 0 0;
          background-size: 100%;
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
          &-user {
            width: 416px;
            font-size: 16px;
            margin-top: 12px;
            text-align: center;
            span {
              color: var(--font-color-white-one);
              font-family: 'PingFangSC';
            }
            span:first-of-type {
              margin-right: 6px;
            }
          }
          &-team {
            margin-top: 14px;
            font-weight: 500;
            font-size: 20px;
            color: $--font-color-purple-2;
            span {
              margin-right: 6px;
            }
          }
        }
        .login-box,
        .pwd-box {
          padding: 82px 85px 74px;
          .ant-form {
            /deep/ .ant-form-item {
              .ant-form-item-control-wrapper {
                width: 100%;
                .ant-form-item-children {
                  position: relative;
                  .ant-input {
                    background-color: $--bg-color-gray-8 !important;
                    border-radius: 4px;
                    border: none;
                    height: 48px;
                    font-size: 16px;
                    color: $--font-color-gray-2;
                    transition: background-color 0.3s;
                    &:hover {
                      background: $--bg-color-gray-fourth;
                    }
                    &:focus {
                      box-shadow: 0 0 0 0;
                      background: $--bg-color-gray-fourth;

                      &::-webkit-contacts-auto-fill-button {
                        opacity: 0;
                      }
                    }
                    &::-webkit-credentials-auto-fill-button {
                      display: none !important;
                    }
                    &:-webkit-autofill {
                      box-shadow: 0 0 1000px #f8f7fa inset !important;
                      -webkit-text-fill-color: #211d29 !important;
                      caret-color: #211d29 !important;
                    }
                  }
                  .verify-code {
                    position: absolute;
                    right: 12px;
                    top: -17px;
                    font-size: 14px;
                    color: $--font-color-gray-1;
                    .get-code {
                      cursor: pointer;
                    }
                    .down-time {
                      color: $--font-color-gray-3;
                    }
                  }
                }
              }
            }
          }
          .login-btn {
            margin-bottom: 12px;
            display: block;
            font-weight: 500;
            font-size: 16px;
            color: $--color-font-twelfth;
          }
          .ant-checkbox-wrapper {
            /deep/ span {
              color: $--font-color-gray-1;
              font-size: 12px;
              .protocol {
                color: $--font-color-purple-2;
              }
            }
            /deep/ .ant-checkbox {
              .ant-checkbox-input {
                border: 1px solid $--border-color-gray-1;
              }
              .ant-checkbox-inner {
                border: 1px solid $--border-color-gray-1;
              }
              &.ant-checkbox-checked .ant-checkbox-inner {
                background-color: $--font-color-purple-1 !important;
                border-color: $--font-color-purple-1;
              }
            }
          }
        }
        .login-box {
          height: 600px;
          &.is-invite {
            height: 478px;
            padding-top: 48px;
          }
          .ant-form {
            height: 200px;
            position: relative;
            .appid-list {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              width: 100%;
              border-radius: 4px;
              border: 1px solid $--bg-color-gray-fourth;
              background-color: $--bg-color-gray-fourth;
              z-index: 2;
              &::before,
              &::after {
                content: '';
                display: block;
                border-width: 10px;
                position: absolute;
                top: -21px;
                left: 20px;
                border-style: solid dashed dashed solid;
                border-color: transparent transparent $--bg-color-gray-fourth
                  transparent;
                font-size: 0;
                line-height: 0;
              }
              &::after {
                top: -20px;
                border-color: transparent transparent $--bg-color-gray-fourth
                  transparent;
              }
              .item {
                cursor: pointer;
                color: $--font-color-gray-2;
                text-align: left;
                padding: 0 12px;
                transition: color 0.5s;
                &:hover {
                  color: var(--main-high-light-color);
                }
              }
              &.account {
                top: 60px;
              }
              &.pwd {
                top: 130px;
              }
            }
            .forget-pwd {
              margin-top: -18px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              &.client {
                justify-content: space-between;
              }
              .checkbox-password {
                display: flex;
                align-items: center;

                /deep/ .ant-checkbox {
                  top: 0;
                  &.ant-checkbox-checked .ant-checkbox-inner {
                    background-color: $--font-color-purple-1 !important;
                    border-color: $--font-color-purple-1;
                  }
                }
              }
              .forget-btn {
                font-size: 14px;
                color: $--font-color-gray-1;
                cursor: pointer;
              }
            }
          }
          .login-tab {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 58px;
            .msg,
            .pwd {
              font-family: PingFangSC-Regular;
              font-size: 22px;
              color: $--font-color-gray-1;
              transition: all 0.3s;
              cursor: pointer;
              font-weight: 400;
              &:hover {
                color: $--font-color-purple-1;
              }
              &.active {
                color: $--font-color-purple-1;
                font-weight: bold;
              }
            }
            .line {
              width: 1px;
              height: 16px;
              background: $--color-grey-tenth;
              margin: 0 24px;
            }
          }
        }
        .pwd-box {
          height: 722px;
          .title {
            font-weight: 500;
            font-size: 22px;
            color: $--font-color-gray-2;
            margin-bottom: 58px;
          }
          .ant-form {
            height: 350px;
          }
          .remember-pwd {
            margin-top: 58px;
            text-align: center;
            font-size: 14px;
            color: $--font-color-gray-1;
            span {
              cursor: pointer;
              color: $--font-color-purple-2;
            }
          }
        }
      }
      .login-select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 80px 85px 108px;
        &-title {
          font-weight: 500;
          font-size: 36px;
          color: $--font-color-gray-2;
          margin-bottom: 50px;
        }
        .team-box {
          width: 100%;
          height: 300px;
          overflow-y: auto;
          margin: 0;
          div {
            width: 100%;
            height: 48px;
            border: 1px solid $--border-color-gray-2;
            border-radius: 4px;
            margin-bottom: 12px;
            padding: 0 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            &.active {
              border: 1px solid $--font-color-purple-1;
              background: $--bg-color-gray-8;
            }
            .name {
              font-size: 16px;
              color: $--font-color-gray-2;
            }
            .icon {
              i {
                width: 20px;
                height: 20px;
                color: $--font-color-purple-1;
              }
            }
          }
        }
        &-btn {
          width: 100%;
          height: 48px;
          margin-top: 64px;
          border-radius: 4px;
        }
      }
    }

    .bottom-title {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      font-size: 14px;
      color: $--font-color-gray-1;
    }
  }
  .phone-wrap {
    height: 100%;
    background: var(--font-color-white-one);
    padding: 32px 30px;
    &.unshow {
      display: none;
    }
    .logo {
      width: 90px;
      height: 21px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .login-container {
      margin-top: 86px;
      h2 {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 22px;
        color: $--font-color-gray-2;
      }
      .ant-input-affix-wrapper {
        margin: 40px 0 22px;
        /deep/ .ant-input {
          background-color: $--bg-color-gray-8 !important;
          border-radius: 4px;
          border: none;
          width: 100%;
          height: 40px;
          font-size: 16px;
          color: $--font-color-gray-2;
          transition: background-color 0.3s;
          &:hover {
            background: $--bg-color-gray-fourth;
          }
          &:focus {
            box-shadow: 0 0 0 0;
            background: $--bg-color-gray-fourth;
          }
        }
      }
      .login-btn {
        height: 40px;
      }
      .ant-checkbox-wrapper {
        margin-top: 22px;
        /deep/ span {
          color: $--font-color-gray-1;
          font-size: 12px;
          .protocol {
            color: $--font-color-purple-2;
          }
        }
        /deep/ .ant-checkbox {
          .ant-checkbox-input {
            border: 1px solid $--border-color-gray-1;
          }
          .ant-checkbox-inner {
            border: 1px solid $--border-color-gray-1;
          }
          &.ant-checkbox-checked .ant-checkbox-inner {
            background-color: $--font-color-purple-1 !important;
            border-color: $--font-color-purple-1;
          }
        }
      }
    }
  }
}
.check-light-confirm .protocol-link {
  color: $--font-color-purple-1;
}
</style>
